export class CollectionSeoDescription extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.readMore, 'click', this.onClickReadMore.bind(this))
    this.listeners.add(this.readLess, 'click', this.onClickReadLess.bind(this))
  }

  /**
   * @param {MouseEvent} e
   *
   * @returns {void}
   */
  onClickReadMore (e) {
    this.bodyTruncate.className = 'clc-SeoDescription_BodyDisable'
    this.bodyTruncate.setAttribute('hidden', 'true')
    this.bodyTruncate.setAttribute('aria-hidden', 'true')

    this.bodyFull.removeAttribute('hidden')
    this.bodyFull.removeAttribute('aria-hidden')
    this.bodyFull.className = 'clc-SeoDescription_BodyEnable'
  }

  /**
   * @param {MouseEvent} e
   *
   * @returns {void}
   */
  onClickReadLess (e) {
    this.bodyTruncate.className = 'clc-SeoDescription_BodyEnable'
    this.bodyTruncate.removeAttribute('hidden')
    this.bodyTruncate.removeAttribute('aria-hidden')

    this.bodyFull.setAttribute('hidden', 'false')
    this.bodyFull.setAttribute('aria-hidden', 'false')
    this.bodyFull.className = 'clc-SeoDescription_BodyDisable'
  }

  get readMore () {
    return this.els?.readMore?.element
  }

  get readLess () {
    return this.els?.readLess?.element
  }

  get bodyTruncate () {
    return this.els?.bodyTruncate?.element
  }

  get bodyFull () {
    return this.els?.bodyFull?.element
  }
}

if (!customElements.get('collection-seo-description')) {
  customElements.define('collection-seo-description', CollectionSeoDescription)
}
